/**
 * Удаляем лишние слеши
 * @param {string} url
 * @return {string}
 */
function parseUrl(url = '') {
  const regexp = new RegExp('([^:]\\/)\\/+', 'g');
  return url.replace(regexp, '$1');
}

export default parseUrl;
